import React, { Component } from 'react';
import '../myutils';
import {
    translate
} from 'react-admin'; 
import Button from '@material-ui/core/Button';
import Delete from '@material-ui/icons/Delete';
import Block from '@material-ui/icons/Lock';
import Unblock from '@material-ui/icons/LockOpen';
import { configAPI } from '../config'
import { push as pushAction } from 'react-router-redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Tooltip } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';

class UpdateEntries extends Component {

    state = {
        open: false,
    };
    constructor(props) {
        super(props);
        this.state = {
            record: false
        }
    }

    handleClick = (e, record) => {
        this.handleClose(e);
        var entries = sessionStorage.selectedEntry;
        entries = entries.substring(0, entries.length - 1);

        if (this.props.handleCloseMenu) this.props.handleCloseMenu();

        const { push } = this.props;

        const ReqUpdate = new Request(configAPI.api.prod + '/UpdateTemplateEntries?token=' + sessionStorage.B.encodeDecode() +
                        '&action=' + this.props.action + '&templateId=' + this.props.templateId + '&rowids=' + entries);
        fetch(ReqUpdate)
            .then(response => response.json())
            .then(json => {
                if (json.responseStatus === 'OK') {
                    push('/Templates');
                    push('/Templates/' + this.props.templateId+'/1');
                    push('/Templates/' + this.props.templateId+'/2');
                }
            });
    }

    handleClickOpen = (e) => {
        e.stopPropagation();
        this.setState({ open: true });
    };

    handleClose = (e) => {
        e.stopPropagation();
        this.setState({ open: false });
    };

    render() {
        const { translate, record, action } = this.props;
        return (
            <Tooltip title={(action==='delete')?translate(`trans.deleteEntries`):(action==='block')?translate(`trans.blockEntries`):translate(`trans.unblockEntries`)}>
                <IconButton onClick={(e) => {if (sessionStorage.selectedEntry!=='') this.handleClickOpen(e)}}>
                {(action==='delete')&&<Delete/>}
                {(action==='block')&&<Block/>}
                {(action==='unblock')&&<Unblock/>}
                    <Dialog
                        open={this.state.open}
                        onClose={this.handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{(action==='delete')?translate(`trans.ApproveDeleteEntries`):(action==='block')?translate(`trans.ApproveBlockEntries`):translate(`trans.ApproveUnblockEntries`)}</DialogTitle>
                        <DialogActions>
                            <Button onClick={(e) => this.handleClose(e)} color="primary">
                                {translate(`trans.cancel`)}
                            </Button>
                            <Button onClick={(e) => this.handleClick(e, record)} color="primary" autoFocus>
                                {translate(`trans.ok`)}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </IconButton>
            </Tooltip>
        );
    }
}

UpdateEntries.propTypes = {
    push: PropTypes.func,
    record: PropTypes.object,
};

export default connect(null, {
    push: pushAction,
})(translate(UpdateEntries));
